import i18next from "i18next";
const processAppointmentTypeJSON = () => {
    const appointmentType_rootSource = [
        {
            id: "conference",
            text: i18next.t("appointment_types:conference"),
            filtered: true,
            icon: "bi-person-bounding-box",
        },
        {
            id: "follow_up",
            text: i18next.t("appointment_types:follow_up"),
            filtered: true,
            icon: "bi-arrow-repeat",
        },
        {
            id: "genetic_disclosure",
            text: i18next.t("appointment_types:genetic_disclosure"),
            filtered: true,
            icon: "bi-person-bounding-box",
        },
        {
            id: "icf_consultation",
            text: i18next.t("appointment_types:icf_consultation"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "intake",
            text: i18next.t("appointment_types:intake"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "investigator_meeting",
            text: i18next.t("appointment_types:investigator_meeting"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "monitoring",
            text: i18next.t("appointment_types:monitoring"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "phone_call",
            text: i18next.t("appointment_types:phone_call"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "phone_pre_evaluation",
            text: i18next.t("appointment_types:phone_pre_evaluation"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "pre_screener",
            text: i18next.t("appointment_types:pre_screener"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "reeval",
            text: i18next.t("appointment_types:reeval"),
            filtered: true,
            icon: "bi-chat-left-dots",
        },
        {
            id: "re_swab",
            text: i18next.t("appointment_types:re_swab"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "study_visit",
            text: i18next.t("appointment_types:study_visit"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "sae_meeting",
            text: i18next.t("appointment_types:sae_meeting"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "siv",
            text: i18next.t("appointment_types:siv"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "task",
            text: i18next.t("appointment_types:task"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "team_meeting",
            text: i18next.t("appointment_types:team_meeting"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "clinic_closed",
            text: i18next.t("appointment_types:clinic_closed"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "vacation",
            text: i18next.t("appointment_types:vacation"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "unavailable",
            text: i18next.t("appointment_types:unavailable"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "work_from_home",
            text: i18next.t("appointment_types:work_from_home"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "shadowing",
            text: i18next.t("appointment_types:shadowing"),
            filtered: true,
            icon: "bi-person-lines-fill",
        },
        {
            id: "voidtype",
            text: i18next.t("appointment_types:voidtype"),
            filtered: true,
            icon: "bi-circle",
        },
    ];
    let appointmentType;
    if (localStorage.appointment_types) {
        appointmentType = JSON.parse(localStorage.appointment_types);
    } else {
        appointmentType = appointmentType_rootSource;
    }
    return appointmentType;
};
export default processAppointmentTypeJSON;
